import { action } from 'typesafe-actions';
import { DetalhesOrdemCargaTypes, DetalhesOrdemCarga } from './types';

export const loadRequest = (codEmp: number, ordemCarga: number) =>
  action(DetalhesOrdemCargaTypes.LOAD_REQUEST, {
    codEmp,
    ordemCarga,
  });
export const loadSuccess = (data: DetalhesOrdemCarga) =>
  action(DetalhesOrdemCargaTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(DetalhesOrdemCargaTypes.LOAD_FAILURE);

export const clearDetalhesOrdemCarga = () =>
  action(DetalhesOrdemCargaTypes.CLEAR_DETALHES_ORDEMCARGA);
